import React, { useEffect, useState } from "react";
import {
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  useRedirect,
  useRefresh,
  useDataProvider,
  CreateProps,
} from "react-admin";
import { AcademicYearResources, GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateRangeInput from "components/CustomDateRangeInput";
import SaveButton from "./components/SaveButton";
import moment from "moment";
import { typeList } from "./const";
import CreateWrapper from "../../components/CreateWrapper";

const HolidayCreate = (props: CreateProps) => {
  const [holidays, setHolidays] = useState<IHoliday[]>([]);
  const provider = useDataProvider();
  const param = GetParam();
  const redirect = useRedirect();
  const refresh = useRefresh();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    {
      title: "Academic Years",
      link: `/schools/${param.get("schoolId")}/show/4`,
    },
    {
      title: "Holidays",
      link: `/academicYears/${param.get("academicYearId")}/show/2`,
      params: `?schoolId=${param.get("schoolId")}`,
    },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = () => {
    redirect(
      `/academicYears/${param.get(
        "academicYearId",
      )}/show/2?schoolId=${param.get("schoolId")}`,
    );
    refresh();
  };

  const academicYearResources = AcademicYearResources(
    Number(param.get("academicYearId")),
  );

  useEffect(() => {
    provider
      .getList("holidays", {
        filter: { AcademicYearId: Number(param.get("academicYearId")) },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then(({ data }) => {
        setHolidays(data as IHoliday[]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let excludeDates: IExcludeDates[] = [];
  holidays.forEach((holiday: IHoliday) => {
    let temp: IExcludeDates = {
      startDate: holiday.date,
    };

    excludeDates.push(temp);
  });

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Regular Holiday"
        onSuccess={CustomRedirect}
        {...props}
      >
        <SimpleForm toolbar={<SaveButton />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">
                School, Academic Year and Holiday Type
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select Academic Year"
                source="academicYearId"
                reference="academicYears"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <AutocompleteInput
                source="type"
                choices={typeList}
                validate={required()}
                disabled
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={8}>
              <CustomDateRangeInput
                fromSource="fromDate"
                toSource="toDate"
                fromLabel="From Date *"
                toLabel="To Date *"
                parentStartDate={moment
                  .utc(academicYearResources?.startDate)
                  .format("yyyy-MM-DD")}
                fromMaxDate={moment
                  .utc(academicYearResources?.endDate)
                  .format("yyyy-MM-DD")}
                toMaxDate={moment
                  .utc(academicYearResources?.endDate)
                  .format("yyyy-MM-DD")}
                excludeDates={excludeDates}
                gridItemWidth={6}
              />
            </Grid>
            <Grid item xs={4}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default HolidayCreate;
